export default __webpack_public_path__ + "static/media/current-shipping.27e38808.png";